import { useEffect, useState } from 'react';
import type { UserContextInterface } from './context';
import { FetchUser } from './user-fetch';

function useUser(defaults?: UserContextInterface): UserContextInterface {
  const [user, setUser] = useState(defaults?.user);
  const [clientID, setClientID] = useState(defaults?.clientID);

  const fetchUserAndStore = async () => {
    try {
      const user = await new FetchUser().usersMeGet();

      if (user?.entity) {
        setUser(user);
        setClientID(user.entity.client_uuid);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const userRefetch = () => fetchUserAndStore();

  useEffect(() => {
    if (defaults !== undefined) return;
    if (!user) fetchUserAndStore();
  }, [user, defaults]);

  return { user, clientID, userRefetch };
}

export default useUser;
